document.addEventListener('DOMContentLoaded', () => {
  const customDropdown = document.getElementById('custom-dropdown');
  const customOptions = document.getElementById('custom-options');

  function toggleOptions() {
    customOptions.style.display = customOptions.style.display === 'block' ? 'none' : 'block';
    customDropdown.classList.toggle('active');
  }

  const optionItems = document.querySelectorAll('.custom-option');
  optionItems.forEach((item) => {
    item.addEventListener('click', () => {
      const selectedOption = item.getAttribute('data-value');

      if (selectedOption !== '#') {
        window.location.href = selectedOption;
      }

      customOptions.style.display = 'none';
      customDropdown.querySelector('button').textContent = item.textContent;
    });
  });

  // Determine the active page URL
  const activePageURL = window.location.pathname;

  optionItems.forEach((item) => {
    const optionValue = item.getAttribute('data-value');
    if (optionValue === activePageURL) {
      customDropdown.querySelector('button').textContent = item.textContent;
    }
  });

  customDropdown.querySelector('button').addEventListener('click', toggleOptions);
});
